import React, { useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { Button } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import SupersetDashboardEmbed from '@spark/ui-components/components/Dashboard/SupersetDashboardEmbed';
import { useSupersetDashboardToken } from '../hooks/useSupersetDashboardToken';

const DEFAULT_DASHBOARD_UUID = 'b02a1e96-e2a6-4902-9bc8-48a43af96e8f';

const getDashboardUuidFromEnv = (envValue, fallback) => {
  const normalized = String(envValue || '').trim();
  return normalized || fallback;
};

const DashboardMotoristasMain = () => {
  const dashboardUuid = useMemo(
    () => getDashboardUuidFromEnv(
      process.env.REACT_APP_SUPERSET_DASHBOARD_UUID_MOTORISTAS,
      DEFAULT_DASHBOARD_UUID
    ),
    []
  );

  const { loading, data, error, reload, fetchGuestToken } = useSupersetDashboardToken(dashboardUuid);

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader routeSegments={[{ name: 'Início' }, { name: 'Dashboard' }, { name: 'Motoristas' }]} />
        </Col>
      </Row>

      <Row className="flex-grow-1">
        <Col md={12} className="d-flex flex-column" style={{ minHeight: 'calc(100vh - 120px)' }}>
          <Card className="flex-grow-1 d-flex flex-column">
            <CardBody className="d-flex flex-column flex-grow-1 p-2">
              <div className="d-flex align-items-center justify-content-end mb-2">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={reload}
                  disabled={loading}
                  title="Atualizar dashboard"
                  aria-label="Atualizar dashboard"
                >
                  {loading ? (
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Carregando...</span>
                    </div>
                  ) : (
                    <Icon name="refresh" size={18} />
                  )}
                </Button>
              </div>

              <div className="flex-grow-1 d-flex flex-column" style={{ minHeight: 0 }}>
                {error || !data?.token ? (
                  <div className="text-muted">
                    {loading ? 'Carregando dashboard...' : 'Não foi possível carregar o dashboard.'}
                  </div>
                ) : (
                  <SupersetDashboardEmbed
                    instanceUrl={data.instanceUrl}
                    dashboardUuid={data.dashboardUuid}
                    fetchGuestToken={fetchGuestToken}
                    hideTitle
                    style={{ flex: 1, minHeight: 0, height: '100%' }}
                  />
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DashboardMotoristasMain;
